<template>
  <div class="m-0 p-0 select-input-wrapper">
    <Field
      v-if="validation"
      :rules="validation"
      v-slot="{ field, errorMessage, handleBlur }"
      :name="name"
      :label="label"
      v-model="localSelected"
    >
      <label v-if="labelOnTop" :style="labelOnTopStyle" class="input-label">
        {{$t(label)}}
        <span v-if="validation.includes('required')">*</span>
        <span v-else>{{$t('(optional)')}}</span>
      </label>
      <div :style="styles" class="selectInputWrapper m-0 p-0 col-12">
        <select
          class="form-control"
          :class="[{ 'is-invalid': errorMessage }]"
          v-bind="field"
          required
          ref="select"
          @change="updateComponent"
        >
          <option value disabled :selected="!selectedValue" hidden></option>
          <option
            v-for="option in filteredOptions"
            :key="option.value"
            :selected="option.value == selectedValue"
            :disabled="option.disabled"
            :value="option.value"
          >{{$t(option.text)}}</option>
        </select>
        <div class="arrow-icon">
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.41 0.589996L6 5.17L10.59 0.589996L12 2L6 8L0 2L1.41 0.589996Z" fill="#003DA5" />
          </svg>
        </div>
        <span v-if="label && !localSelected" class="select-placeholder">{{ label }}</span>
      </div>
      <div class="validation-error" v-if="errorMessage">{{errorMessage}}</div>
    </Field>
    <template v-else>
      <div class="selectInputWrapper">
        <select
          class="form-control"
          required
          ref="select"
          :name="name"
          v-model="localSelected"
          @change="updateComponent"
        >
          <option value disabled :selected="!selectedValue" hidden></option>
          <option
            v-for="option in filteredOptions"
            :key="option.value"
            :selected="option.value == selectedValue"
            :disabled="option.disabled"
            :value="option.value"
          >{{option.text}}</option>
        </select>
        <div class="arrow-icon">
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.41 0.589996L6 5.17L10.59 0.589996L12 2L6 8L0 2L1.41 0.589996Z" fill="#003DA5" />
          </svg>
        </div>
        <span v-if="label && !localSelected" class="select-placeholder">{{ label }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { Field } from 'vee-validate';

export default {
  name: "select-input",
  components: {
    Field
  },
  data () {
    let initial = this.modelValue || this.selectedValue || "";
    return {
      localSelected: initial
    };
  },
  props: {
    field: {
      required: false,
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: String,
      required: false,
      default: ""
    },
    selectedValue: {
      type: String,
      required: false,
      default: ""
    },
    placeholder: {
      type: String,
      required: false,
      default: "Select Something"
    },
    validation: {
      type: String,
      required: false
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    },
    labelOnTop: {
      type: Boolean,
      default: false
    },
    labelOnTopStyle: {
      type: Object,
      default: () => {}
    },
    forCountry: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed : {
    filteredOptions () {
      if(this.forCountry){
        return this.options.filter((option) => option.code === this.locale )
      }else{
        return this.options
      }
    }
  },
  mounted() {
    if (this.forCountry && this.filteredOptions.length > 0) {
      const localeOption = this.filteredOptions[0];
      if (this.localSelected !== localeOption.value) {
        this.localSelected = localeOption.value;
        this.$emit("update:modelValue", localeOption.value);
      }
    }
  },
  methods: {
    updateComponent (event) {
      this.localSelected = event.target.value;
      this.$refs.select.style.color = "#000";
      this.$emit("component-updated", {
        text: event.target.value
      });
      this.$emit("update:modelValue", event.target.value);
      this.$eventHub.emit("checkCountryForPLZ", event.target.value);
    }
  },
  watch: {
    modelValue (newValue) {
      if (newValue !== undefined) {
        this.localSelected = newValue;
      }
    }
  }
};
</script>

<style scoped lang="scss">

.selectInputWrapper {
  position: relative;
  margin: 5px 0;
  select {
    background: white;
    outline: 0;
    box-shadow: none;
    transition: border-color 0.15s;
    border-radius: 8px !important;
    border: 1px solid var(--input-border-color) !important;
    box-sizing: border-box !important;
    padding-left: 10px !important;
    height: 48px !important;
    cursor: pointer;
    width: 100%;
    letter-spacing: 0.5px;
    color: #757575 !important;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    // ARROW
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';

    &.is-invalid {
      border-color: #dc3545 !important;
    }
  }
  .error_min {
    width: 16px;
  }
  .inputError {
    position: absolute;
    top: 12px;
    right: 10px;
  }
}

.select-placeholder {
  position: absolute;
  top: 30%;
  left: 0;
  outline: 0;
  box-sizing: border-box !important;
  padding-left: 25px !important;
  letter-spacing: 0.5px;
  color: #757575 !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px
}

.arrow-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 20px;
  width: 100%;
  position: absolute;
  top: 45%;
  right: 25px;
  cursor: pointer;
}
</style>
